import { searchNodeElastic } from './NodeElasticController';

// async search for my suppliers autocomplete
export const asyncSearchForOrigins = (token, inputText) => {
    const options = {
        index: 'country',
        query: {
            bool: {
                must: [{ match: { name: inputText } }],
            },
        },
    };
    return new Promise(resolve => {
        searchNodeElastic(token, options)
            .then(res => {
                resolve(res);
                return res;
            })
            .catch(error => {
                console.log(error);
                resolve(false);
            });
    });
};
